import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Summer2021 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
	    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

	    // Link format:
	    // https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg


	    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

	    let displayArray = [
	    	{
	    		display: 'Designer', 
	    		image: '',
	    		stores: '|',
	    	},
	    	{
	    		display: 'A.JAFFE', 
	    		image: 'ajaffe.svg',
	    		stores: '|chs|bhm|nol|ind|coh|ksc|stl|atx|dfw|ftx|boc|gsc|pit|vab|kcy|hou|',
	    		link: 'designer/a-jaffe',
	    	},
	    	{
	    		display: 'Amden Jewelry', 
	    		image: 'amden.svg',
	    		stores: '|coh|cle|',
	    		link: 'designer/amden',
	    	},
	    	{
	    		display: 'ArtCarved', 
	    		image: '',
	    		stores: '|hou|coh|cle|ksc|dfw|ftx|gsc|ral|pit|kcy|clt|chs|',
	    		link: 'designer/artcarved',
	    	},
	    	{
	    		display: 'Benchmark', 
	    		image: '',
	    		stores: '|bhm|nol|san|ral|',
	    		link: 'designer/benchmark',
	    	},
	    	{
	    		display: 'Christopher Designs', 
	    		image: '',
	    		stores: '|rva|okc|ind|coh|ksc|dfw|ftx|boc|jax|gsc|ral|kcy|',
	    		link: 'designer/christopher-designs',
	    	},
	    	{
	    		display: 'Christian Bauer', 
	    		image: '',
	    		stores: '|rva|bhm|hou|jax|pit|',
	    		link: 'designer/christian-bauer',
	    	},
	    	{
	    		display: 'Classique Creations', 
	    		image: '',
	    		stores: '|bhm|nol|okc|stl|dfw|ftx|pit|vab|',
	    		link: 'designer/classique',
	    	},
	    	{
	    		display: 'Color Jewels', 
	    		image: '',
	    		stores: '|clt|dfw|ral|',
	    		link: '',
	    	},
	    	{
	    		display: 'Fana', 
	    		image: '',
	    		stores: '|okc|ind|ind|san|atx|boc|jax|',
	    		link: 'designer/fana',
	    	},
	    	{
	    		display: 'Furrer Jacot', 
	    		image: '',
	    		stores: '|chs|clt|ind|coh|cle|san|atx|dfw|ftx|boc|',
	    		link: 'designer/furrer-jacot',
	    	},
	    	{
	    		display: 'Gabriel & Co.', 
	    		image: '',
	    		stores: '|stl|bhm|',
	    		link: 'designer/gabriel',
	    	},
	    	{
	    		display: 'C. Gonshor', 
	    		image: '',
	    		stores: '|rva|hou|atx|dfw|',
	    		link: 'designer/c-gonshor',
	    	},
	    	{
	    		display: 'Heera Motti', 
	    		image: 'simong.svg',
	    		stores: '|chs|clt|ral|',
	    		link: '',
	    	},
	    	{
	    		display: 'Kirk Kara', 
	    		image: '',
	    		stores: '|clt|bhm|boc|ral|',
	    		link: 'designer/kirk-kara',
	    	},
	    	{
	    		display: 'Jeff Cooper', 
	    		image: '',
	    		stores: '|nol|hou|san|atx|',
	    		link: 'designer/jeff-cooper',
	    	},
	    	{
	    		display: 'Mastoloni', 
	    		image: 'simong.svg',
	    		stores: '|chs|nol|san|gsc|pit|',
	    		link: 'designer/mastoloni3',
	    	},
	    	{
	    		display: 'Michael M', 
	    		image: 'mm.svg',
	    		stores: '|chs|clt|nol|okc|boc|',
	    		link: 'designer/michael-m',
	    	},
	    	{
	    		display: 'Novell', 
	    		image: '',
	    		stores: '|rva|okc|ksc|vab|kcy|',
	    		link: 'designer/novell',
	    	},
	    	{
	    		display: 'PeJay', 
	    		image: '',
	    		stores: '|cle|',
	    		link: 'designer/pejay',
	    	},
	    	{
	    		display: 'Simon G.', 
	    		image: 'simong.svg',
	    		stores: '|chs|clt|hou|okc|cle|san|dfw|ftx|ral|vab|',
	    		link: 'designer/simon-g-jewelry',
	    	},
	    	{
	    		display: 'Tacori', 
	    		image: 'tacori.svg',
	    		stores: '|chs|rva|ind|coh|cle|atx|vab|',
	    		link: 'designer/tacori',
	    	},
	    	{
	    		display: 'Uneek', 
	    		image: 'uneek.svg',
	    		stores: '|hou|boc|jax|',
	    		link: 'designer/uneek',
	    	},
	    	{
	    		display: 'Verragio', 
	    		image: 'ver.svg',
	    		stores: '|clt|rva|bhm|nol|coh|ksc|stl|dfw|ftx|jax|gsc|ral|pit|kcy|',
	    		link: 'designer/verragio',
	    	},
	    ];
	    

	    let designerLocationArray = [
	    	{
					display: 'Select Location',
					value: '',
					dates: '',
					page: '',
				},
	    	{
				display: 'Austin, TX',
				value: 'atx',
				dates: 'July 21 - 25',
				page: 'austin',
			},
			{
				display: 'Birmingham, AL',
				value: 'bhm',
				dates: 'July 14 - 18',
				page: 'birmingham',
			},
			{
				display: 'Boca Raton, FL',
				value: 'boc',
				dates: 'July 21 - 25',
				page: 'boca-raton',
			},
			{
				display: 'Charleston, SC',
				value: 'chs',
				dates: 'July 14 - 18',
				page: 'charleston',
			},
			{
				display: 'Charlotte, NC',
				value: 'clt',
				dates: 'July 14 - 18',
				page: 'charlotte',
			},
			{
				display: 'Cleveland, OH',
				value: 'cle',
				dates: 'July 14 - 18',
				page: 'cleveland',
			},
			{
				display: 'Columbus, OH',
				value: 'coh',
				dates: 'July 14 - 18',
				page: 'columbus',
			},
			{
				display: 'Dallas, TX',
				value: 'dfw',
				dates: 'July 21 - 25',
				page: 'dallas',
			},
			{
				display: 'Frisco, TX',
				value: 'ftx',
				dates: 'July 21 - 25',
				page: 'frisco',
			},
			{
				display: 'Greenville, SC',
				value: 'gsc',
				dates: 'July 21 - 25',
				page: 'greenville',
			},
			{
				display: 'Houston, TX',
				value: 'hou',
				dates: 'July 14 - 18',
				page: 'houston',
			},
			{
				display: 'Indianapolis, IN',
				value: 'ind',
				dates: 'July 14 - 18',
				page: 'indianapolis',
			},
			{
				display: 'Jacksonville, FL',
				value: 'jax',
				dates: 'July 21 - 25',
				page: 'jacksonville',
			},
			{
				display: 'Kansas City, KS',
				value: 'kcy',
				dates: 'July 21 - 25',
				page: 'kansas-city',
			},
			{
				display: 'New Orleans, LA',
				value: 'nol',
				dates: 'July 14 - 18',
				page: 'new-orleans',
			},
			{
				display: 'Oklahoma City, OK',
				value: 'okc',
				dates: 'July 14 - 18',
				page: 'oklahoma-city',
			},
			{
				display: 'Pittsburgh, PA',
				value: 'pit',
				dates: 'July 21 - 25',
				page: 'pittsburgh',
			},
			{
				display: 'Raleigh, NC',
				value: 'ral',
				dates: 'July 21 - 25',
				page: 'raleigh',
			},
			{
				display: 'Richmond, VA',
				value: 'rva',
				dates: 'July 14 - 18',
				page: 'richmond',
			},
			{
				display: 'St. Louis, MO',
				value: 'stl',
				dates: 'July 21 - 25',
				page: 'st-louis',
			},
			{
				display: 'San Antonio, TX',
				value: 'san',
				dates: 'July 21 - 25',
				page: 'san-antonio',
			},
			{
				display: 'Virginia Beach, VA',
				value: 'vab',
				dates: 'July 21 - 25',
				page: 'virginia-beach',
			},
	  ];

		this.state = {
			locations: newArray,
			// designers: designerArray,
			designerLocationArray: designerLocationArray,
			displayArray: displayArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	openIntercom() {
    acquireIO.max();
  }

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  getShowDates(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.dates;
  		}
  	}
  	return '';
  }

  getShowLink(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.page;
  		}
  	}
  	return '';
  }

  designerNav(page) {
  	if(!page) { return; }
  	this.internalNav(page);
  }

	render() {

		return <div className='Summer2021'>

			<div className='headerSection'>
				<div className='headerSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/header.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/headerm.jpg' />
				</div>
			</div>

			<div className='topSection'>
				<div className='topRow'>
					<div className={'topRowLeft copyBlock copyBlock1'}>
						<div className='topP'>Make your summer golden with special summer savings and exclusively curated jewelry!</div>
						<div className='topP'>Shop with us online or in-store and take advantage of:</div>
						<div className='topTitle'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2021/v2/landing/copy.svg' />
						</div>
					</div>
					<div className={'topRowRight imgBlock imgBlock1'}>
						<div className={'linkBlock linkBlock1'} onClick={() => this.internalNav('setting/SMD1447730')}></div>
					</div>
				</div>
				<div className='topRow'>
					<div className={'topRowLeft imgBlock imgBlock2 desktopMakeup'}>
						<div className={'linkBlock linkBlock1'} onClick={() => this.internalNav('jewelry/EHOOP03859')}></div>
						<div className={'linkBlock linkBlock2'} onClick={() => this.internalNav('jewelry/BDSAP03498')}></div>
						<div className={'linkBlock linkBlock3'} onClick={() => this.internalNav('jewelry/PRLFE00688')}></div>
					</div>
					<div className={'topRowRight copyBlock'}>
						<div className='topDates'>July 14 - 18</div>
						<div className='topDatesHr'></div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('charlotte')}>Charlotte,&nbsp;NC</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('birmingham')}>Birmingham,&nbsp;AL</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('richmond')}>Richmond,&nbsp;VA</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('charleston')}>Charleston,&nbsp;SC</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('oklahoma-city')}>Oklahoma&nbsp;City,&nbsp;OK</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('indianapolis')}>Indianapolis,&nbsp;IN</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('columbus')}>Columbus,&nbsp;OH</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('cleveland')}>Cleveland,&nbsp;OH</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('new-orleans')}>New&nbsp;Orleans,&nbsp;LA</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('houston')}>Houston,&nbsp;TX</span>
						</div>
					</div>
					<div className={'topRowLeft imgBlock imgBlock2 mobileMakeup'}>
						<div className={'linkBlock linkBlock1'} onClick={() => this.internalNav('jewelry/EHOOP03859')}></div>
						<div className={'linkBlock linkBlock2'} onClick={() => this.internalNav('jewelry/BDSAP03498')}></div>
						<div className={'linkBlock linkBlock3'} onClick={() => this.internalNav('jewelry/PRLFE00688')}></div>
					</div>
				</div>
				<div className='topRow'>
					<div className={'topRowLeft copyBlock'}>
						<div className='topDates'>July 21 - 25</div>
						<div className='topDatesHr'></div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('raleigh')}>Raleigh,&nbsp;NC</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('austin')}>Austin,&nbsp;TX</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('virginia-beach')}>Virginia&nbsp;Beach,&nbsp;VA</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('san-antonio')}>San&nbsp;Antonio,&nbsp;TX</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('dallas')}>Dallas,&nbsp;TX</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('frisco')}>Frisco,&nbsp;TX</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('st-louis')}>St.&nbsp;Louis,&nbsp;MO</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('jacksonville')}>Jacksonville,&nbsp;FL</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('kansas-city')}>Kansas&nbsp;City,&nbsp;KS</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('boca-raton')}>Boca&nbsp;Raton,&nbsp;FL</span>
							<span className='storePipe'>|</span>
							<span className='storeLink' onClick={() => this.internalNav('greenville')}>Greenville,&nbsp;SC</span>
						</div>
						<div className='topDatesRow'>
							<span className='storeLink' onClick={() => this.internalNav('pittsburgh')}>Pittsburgh,&nbsp;PA</span>
						</div>
					</div>
					<div className={'topRowRight imgBlock imgBlock3'}>
						<div className={'linkBlock linkBlock1'} onClick={() => this.internalNav('setting/SMD1412162')}></div>
						<div className={'linkBlock linkBlock2'} onClick={() => this.internalNav('jewelry/EFAND13818')}></div>
						<div className={'linkBlock linkBlock3'} onClick={() => this.internalNav('jewelry/BLDLG11587')}></div>
					</div>
				</div>
			</div>
			
			<div className='shopStripe'>
				<div className='shopTitle'>Shop Online July 14 - 25</div>
				<div className='shopSubtitle'>Discount applied in cart</div>
			</div>

			<div className='designersSection'>
				<div className='designersLeft'>
					<div className='designersP'>Select your Diamonds Direct location below to see which designers will be coming to your area.</div>
					<div className='designersSelectWrapper'>
						<RhinoSelect
							selectClass={'summerSelect'}
							value={this.state.designerLocation}
							options={this.state.designerLocationArray}
							changeMethod={(evt) => this.changeDesignerLocation(evt)} />
					</div>
					<div className='designerResultsWrapper'>
						{this.state.designerLocation ?
							<div className='designerResultsDates'>{this.getShowDates(this.state.designerLocation)}</div> :
							null
						}
						{this.state.designerLocation ?
							<div className='designerResultsHours'>
								<div className='hourLine'>
									<div className='hourDay'>Mon-Fri</div>
									<div className='hourTime'>10am-7pm</div>
								</div>
								<div className='hourDash'>&mdash;</div>
								<div className='hourLine'>
									<div className='hourDay'>Sat</div>
									<div className='hourTime'>10am-7pm</div>
								</div>
								<div className='hourDash'>&mdash;</div>
								<div className='hourLine'>
									<div className='hourDay'>Sun</div>
									<div className='hourTime'>12pm-5pm</div>
								</div>
							</div> :
							null
						}
						<div className='designerHr'></div>
						<div className='dWrap'>
							{this.state.displayArray.map((designer, i) => {

								if(this.state.designerLocation === '') {
									return;
								}

								if(designer.stores.includes(this.state.designerLocation)) {
									console.log(designer);
									return <div className={!designer.link ? 'designerWrapper noHover' : 'designerWrapper'} key={i}>
										<span className={!designer.link ? 'dName noHover' : 'dName'} onClick={() => this.designerNav(designer.link)}>{designer.display}</span>
									</div>;
								} else {
									return null;
								}
							})}
						</div>
						{this.state.designerLocation ?
							<div className='designerResultsButton' onClick={() => this.internalNav(this.getShowLink(this.state.designerLocation))}>Learn More</div> :
							null
						}
					</div>
				</div>
			</div>

			<div className='looksSection'>
				<div className='looksWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/summer2021/jewelry.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/summer2021/jewelrym.jpg' />
					<div className={'lb lb1'} onClick={() => this.internalNav('setting/SMD1447730')}></div>
					<div className={'lb lb2'} onClick={() => this.internalNav('setting/SMD1412162')}></div>
					<div className={'lb lb3'} onClick={() => this.internalNav('jewelry/EFAND13818')}></div>
					<div className={'lb lb4'} onClick={() => this.internalNav('jewelry/BLDLG11587')}></div>
				</div>
			</div>

			<div className='formSection'>
				
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className='formP'>Walk-in visits are always welcome! But if you'd prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
	                selectClass={'summerSelect'}
	                required={true}
	                value={this.state.inputLocation}
	                options={this.state.locations}
	                changeMethod={(evt) => this.changeLocation(evt)}
	                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
						<div className='formP'>Prefer to shop online? Need some guidance before heading into the store?</div>
						<div className='formWrapper'>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.openIntercom}>Chat with a virtual expert</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='legalSection'>
				<div className='legalInnerWrapper'>*Discount excludes certified diamonds and price protected lines. Cannot be combined with other offers, financing, or previous purchases. <span>Discount applied in cart online.</span> Other exclusions may apply.</div>
			</div>
			
		</div>;
	}
}
export default Summer2021;

function mapStateToProps(state) {
  return {

  };
}

export const Summer2021Container = connect(
  mapStateToProps,
  allActionCreators
)(Summer2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/summer2021/Summer2021.jsx